import { render, staticRenderFns } from "./BSelectWithValidation.vue?vue&type=template&id=fb246634&scoped=true&"
import script from "./BSelectWithValidation.vue?vue&type=script&lang=js&"
export * from "./BSelectWithValidation.vue?vue&type=script&lang=js&"
import style0 from "./BSelectWithValidation.vue?vue&type=style&index=0&id=fb246634&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb246634",
  null
  
)

export default component.exports